import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  content: "内容",
  fontFamily: "字体",
  fontSize: "字体大小",
  fontWeight: "字重",
  borderTypeFlag: "圆角类型", // 1:单独设置  2:全部设置
  color: "字体颜色",
  showReturnText: "显示文字",
  borderRadius: "圆角",
  borderTopLeftRadius: "左上圆角",
  borderTopRightRadius: "右上圆角",
  borderBottomLeftRadius: "左下圆角",
  borderBottomRightRadius: "右下圆角",
  iconWidth: "图标大小",
  iconMargin: "图标文字间距",
  background: "背景颜色"
}
export const getOptDes = toSelectOpt.bind(this, optDes)
